import { Service } from '../store/services/types'

export const getTotalServicesPrice = (selectedServices: Service[]) =>
  selectedServices.reduce((acc, service) => acc + parseInt(service.preis, 10), 0)

export const getTotalServicesDuration = (selectedServices: Service[]) => selectedServices.reduce((acc, service) => acc + service.minuten, 0)
